import { Ingredient } from "../types/ingredient";

export const ingredients: Ingredient[] = [
  {
    id: "he-lavande-fine",
    name: "Lavande fine AOP",
    inci: "Lavandula Angustifolia Oil",
    category: "huiles-essentielles",
    certification: "COSMOS Organic",
    moq: "1 kg",
    packaging: "Flacon alu 1 kg · fût inox 25 kg",
    availability: "stock",
    availabilityLabel: "En stock",
  },
  {
    id: "he-immortelle",
    name: "Immortelle de Corse-Provence",
    inci: "Helichrysum Italicum Flower Oil",
    category: "huiles-essentielles",
    certification: "COSMOS Organic",
    moq: "100 g",
    packaging: "Flacon alu 100 g · 500 g",
    availability: "limited",
    availabilityLabel: "Stock limité",
  },
  {
    id: "he-romarin-verbenone",
    name: "Romarin à verbénone",
    inci: "Rosmarinus Officinalis Leaf Oil",
    category: "huiles-essentielles",
    certification: "Ecocert",
    moq: "500 g",
    packaging: "Flacon alu 1 kg · 5 kg",
    availability: "stock",
    availabilityLabel: "En stock",
  },
  {
    id: "hy-lavande",
    name: "Hydrolat de lavande",
    inci: "Lavandula Angustifolia Flower Water",
    category: "hydrolats",
    certification: "COSMOS Organic",
    moq: "10 kg",
    packaging: "Bidon 10 kg · IBC 1 000 L",
    availability: "stock",
    availabilityLabel: "En stock",
  },
  {
    id: "hy-rose",
    name: "Hydrolat de rose de mai",
    inci: "Rosa Centifolia Flower Water",
    category: "hydrolats",
    certification: "COSMOS Organic",
    moq: "5 kg",
    packaging: "Bidon 5 kg · 20 kg",
    availability: "preorder",
    availabilityLabel: "Récolte mai 2027",
  },
  {
    id: "hv-olive",
    name: "Huile d'olive vierge",
    inci: "Olea Europaea Fruit Oil",
    category: "huiles-vegetales",
    certification: "AB · COSMOS",
    moq: "25 kg",
    packaging: "Fût 25 kg · 200 kg",
    availability: "stock",
    availabilityLabel: "En stock",
  },
  {
    id: "mc-calendula",
    name: "Macérât de calendula",
    inci: "Helianthus Annuus Seed Oil, Calendula Officinalis Flower Extract",
    category: "macerats",
    certification: "COSMOS Organic",
    moq: "5 kg",
    packaging: "Bidon 5 kg · 25 kg",
    availability: "stock",
    availabilityLabel: "En stock",
  },
  {
    id: "co2-romarin",
    name: "Extrait CO₂ de romarin",
    inci: "Rosmarinus Officinalis Leaf Extract",
    category: "extraits-co2",
    certification: "COSMOS Natural",
    moq: "1 kg",
    packaging: "Flacon alu 1 kg",
    availability: "limited",
    availabilityLabel: "Stock limité",
  },
  {
    id: "pd-olivier",
    name: "Poudre de feuilles d'olivier",
    inci: "Olea Europaea Leaf Powder",
    category: "poudres",
    certification: "AB",
    moq: "5 kg",
    packaging: "Sac kraft 5 kg · 20 kg",
    availability: "stock",
    availabilityLabel: "En stock",
  },
];
